// RP-498: cities where price-filter internal linking (do 300 / 400 / 500 / 600 tys zł) is enabled.
// Used to gate the footer price-variant links and the listing budget tile.
export const PRICE_VARIANT_CITIES_SLUGS: string[] = [
    "bialystok",
    "bielsko-biala",
    "blonie",
    "bydgoszcz",
    "bytom",
    "chorzow",
    "czestochowa",
    "dabrowa-gornicza",
    "gdansk",
    "gdynia",
    "gizycko",
    "gliwice",
    "grodzisk-mazowiecki",
    "jelenia-gora",
    "katowice",
    "kielce",
    "kolobrzeg",
    "krakow",
    "lodz",
    "lublin",
    "marki",
    "mikolow",
    "milanowek",
    "minsk-mazowiecki",
    "myslowice",
    "olsztyn",
    "otwock",
    "ozarow-mazowiecki",
    "piaseczno",
    "piastow",
    "poznan",
    "pruszcz-gdanski",
    "pruszkow",
    "radom",
    "reda",
    "ruda-slaska",
    "rumia",
    "rzeszow",
    "siechnice",
    "siemianowice-slaskie",
    "sosnowiec",
    "suwalki",
    "swarzedz",
    "swietochlowice",
    "swinoujscie",
    "szczecin",
    "tomaszow-mazowiecki",
    "torun",
    "tychy",
    "warszawa",
    "wieliczka",
    "wroclaw",
    "zabki",
    "zabrze",
    "zgierz"
];
// RP-498: cities where price-filter internal linking (do 300 / 400 / 500 / 600 tys zł) is enabled.
// Used to gate the footer price-variant links and the listing budget tile.
export const PRICE_VARIANT_CITIES_SLUGS: string[] = [
    "bialystok",
    "bielsko-biala",
    "blonie",
    "bydgoszcz",
    "bytom",
    "chorzow",
    "czestochowa",
    "dabrowa-gornicza",
    "gdansk",
    "gdynia",
    "gizycko",
    "gliwice",
    "grodzisk-mazowiecki",
    "jelenia-gora",
    "katowice",
    "kielce",
    "kolobrzeg",
    "krakow",
    "lodz",
    "lublin",
    "marki",
    "mikolow",
    "milanowek",
    "minsk-mazowiecki",
    "myslowice",
    "olsztyn",
    "otwock",
    "ozarow-mazowiecki",
    "piaseczno",
    "piastow",
    "poznan",
    "pruszcz-gdanski",
    "pruszkow",
    "radom",
    "reda",
    "ruda-slaska",
    "rumia",
    "rzeszow",
    "siechnice",
    "siemianowice-slaskie",
    "sosnowiec",
    "suwalki",
    "swarzedz",
    "swietochlowice",
    "swinoujscie",
    "szczecin",
    "tomaszow-mazowiecki",
    "torun",
    "tychy",
    "warszawa",
    "wieliczka",
    "wroclaw",
    "zabki",
    "zabrze",
    "zgierz"
];
